import { useState, useCallback } from "react";
import { useSelector } from "react-redux";

import type { AllGroupMenuType } from "@/redux/auth/authTypes";
import type { RootState } from "@/redux/rootReducers";

export const useMenuCheck = (
  initalState?: string
): [boolean, (menuName: string, type: string) => boolean] => {
  const allGroupMenu = useSelector(
    (state: RootState) => state.auth.allGroupMenus
  );
  const [isMenuPresent, setIsMenuPresent] = useState<boolean>(
    initalState?.length ? false : true
  );

  const checkMenuFunction = useCallback((menuName: string, type: string) => {
    if (type === "menu") {
      const isMenuNamePresent = allGroupMenu?.find(
        (menu: AllGroupMenuType) => menu.menu_name === menuName
      );
      setIsMenuPresent(!!isMenuNamePresent);
      return !!isMenuNamePresent;
    } else {
      const isMenuNamePresent = allGroupMenu.find(
        (menu: AllGroupMenuType) => menu.front_end_route === menuName
      );
      setIsMenuPresent(!!isMenuNamePresent);
      return !!isMenuNamePresent;
    }
    return false;
  }, []);

  return [isMenuPresent, checkMenuFunction];
};
